import React from "react";

// @ts-ignore
import CheckboxCheck from "!jsx!./assets/checkbox-check.svg";

export default ({ activeFilters = [], setActiveFilters = (_ = []) => { }, filters = [] }) => {

	return (
		<div className="tw-px-[40px]">
			<div className="tw-text-[18px]">Content Type</div>
			{filters.map((filter) => {				
				const enabled = activeFilters.includes(filter.value);
				return (
					<label
						key={filter.value}
						className="tw-flex tw-items-center tw-gap-4 tw-text-[18px] tw-font-sans tw-font-light tw-text-text"
					>
						<span
							className="
							tw-relative tw-inline-block tw-h-[12px] tw-w-[12px] tw-text-secondary
							tw-border tw-border-solid tw-border-secondary tw-bg-gray-300 tw-rounded"
						>
							{enabled ? (
								<CheckboxCheck className="tw-absolute tw-bottom-0 tw-h-[14px] tw-w-[14px]" />
							) : null}
						</span>
						<input
							type="checkbox"
							checked={enabled}
							onChange={(e) => {
								const checked = e.currentTarget.checked;
								const filterEnabled = activeFilters.includes(filter.value);
								if (checked && !filterEnabled) {
									setActiveFilters([filter.value, ...activeFilters]);
								} else if (!checked && filterEnabled) {
									setActiveFilters(activeFilters.filter((f) => f != filter.value));
								}
							}}
							value={filter.value}
						/>
						<span>{filter.display}</span>
					</label>
				);
			})}
		</div>
	);
};
